<div class="row text-center">
  <div class="col">
    <div class="header-icon">
      <ng-container *ngIf="isAcmic; else nonacmicicon">
        <img src="./assets/img/images/icon-key-acmic.svg" alt="key icon"  />
      </ng-container>
      <ng-template #nonacmicicon>
        <svg-create-new-password-svg></svg-create-new-password-svg>
      </ng-template>
    </div>
    <h1 class="title-copy">{{ 'CREATE_NEW_PASSWORD' | translate }}</h1> 
  </div>
</div>
<app-create-password-form [inputs]="createNewPassword"></app-create-password-form>
<div class="row margin-top mt24 text-center">
  <div class="col">
    <mapfre-button
      class="ml-35"
      additionalClasses="link-button red-link small w-100 button-border-red"
      [backIcon]="'assets/img/icons/back-arrow-red.png'"
      [iconClasses]="'align-middle'"
      (click)="goBackAPage()"
      [showIconsCustom]="true"
    >  {{ 'BACK' | translate }}
    </mapfre-button>
  </div>
</div>